module.exports = __webpack_public_path__ + "img/violet_050.256bb2ba.png";